import React, { Component } from 'react';
import { Spin, Row, Col, Icon, Input, Button, message, Divider } from 'antd';
import "../../asset/style/scanner/scanner.css"
import { RegionSelectionConstants } from "../../actionTypes/region_selection.constant"
import { connect } from "react-redux";
import { takeAllPreviews, setDoTilingOnly, unsetDoTilingOnly, selectionDone, selectionCancelled, selectionConfirmed, setScanSpeed, setScanName, initPreviewForScan, takePreview, setSpecimenType, setObjectiveType, setScanOutputFormat } from '../../action/preview_status.action';
import { getSpecimenChooser, getAdminPanel, getBrushPanel, getButtonsPanel, getCanvasComponent, getConfirmedPanel, updateImages, getSpeedPanel, cleanUpExtra, getObjectiveChooser, getScanOutputFormatChanger } from "./slot_component_utils"
import axios from 'axios';
import cookie from "react-cookies";
var querystring = require('querystring');

const { Search } = Input;

const initState = (id, previewStatus, initRegions) => ({
	regions: initRegions,
	selectedSlot:id,
	previewStatus:previewStatus,
	usingBrush: true,
	regionArea: 0, 
	brushSize: 10,
	slide_name: null,
	reading_barcode: false
})

class SlotComponent extends Component {

	constructor(props) {
		super(props);
		this.state = initState(this.props.id, undefined, []);
		this.paint = false;
	}

	onCanvasUpdate = (regions) => {
		this.setState({
			regions: regions
		});
		let url = `/devices/${this.props.device_id}/get_area_mm_from_bounding_box/`;
		var reg = this.state.regions[0];
		if (reg !== undefined) {
			var x1 = parseInt((reg.x * this.props.preview.response.previewWidth) / 100.0);
			var x2 = parseInt(((reg.x + reg.width) * this.props.preview.response.previewWidth) / 100.0);
			var y1 = parseInt((reg.y * this.props.preview.response.previewHeight) / 100.0);
			var y2 = parseInt(((reg.y + reg.height) * this.props.preview.response.previewHeight) / 100.0);
			var data = {
				'slot_id': this.state.selectedSlot, 
				'top_x': x1, 
				'top_y': y1, 
				'bottom_x': x2, 
				'bottom_y': y2
			}
			axios.post(url, querystring.stringify(data)).then(res => {
				this.setState({
					regionArea: res.data.toFixed(0)
				});
			})
			.catch(err => {
					console.log(err);
			});
		}
	}

	componentDidUpdate() {
		let newStatus = (this.props.preview || {}).status;
		if (this.state.selectedSlot !== this.props.id) {
			if (newStatus === RegionSelectionConstants.SELECTION_DONE) {
				this.props.dispatch(selectionCancelled(this.props.id));
			}
			var newRegions = newStatus === RegionSelectionConstants.CONFIRMED ? newRegions = [this.props.preview.region] : [];
			this.setState(Object.assign({}, this.state, initState(this.props.id, undefined, newRegions)));
		} else if (this.state.previewStatus !== newStatus && this.previewCanvas != null) {
			if (newStatus === RegionSelectionConstants.FETCHED_IMAGE || 
				newStatus === RegionSelectionConstants.SELECTION_DONE || 
				newStatus === RegionSelectionConstants.CONFIRMED) {
				let date = new Date();
				updateImages(this.previewCanvas, this.props.preview.response.uploadLocation, 
					this.thresholdCanvas, this.props.preview.response.maskLocation + "?d=" + date.getTime(), this.state.regions);
			}
			this.setState(Object.assign({}, this.state, {previewStatus : newStatus}));
		}

	}

	confirmClicked = () => {
		if (this.props.preview.status === RegionSelectionConstants.FETCHED_IMAGE) {
			this.props.dispatch(selectionDone(this.props.id));
		} else if (this.props.preview.status === RegionSelectionConstants.SELECTION_DONE) {
			let imageURLData = this.thresholdCanvas.toDataURL("image/jpeg");
			let reg = this.state.regions[0];
			let x1 = parseInt((reg.x * this.props.preview.response.previewWidth) / 100.0);
			let x2 = parseInt(((reg.x + reg.width) * this.props.preview.response.previewWidth) / 100.0);
			let y1 = parseInt((reg.y * this.props.preview.response.previewHeight) / 100.0);
			let y2 = parseInt(((reg.y + reg.height) * this.props.preview.response.previewHeight) / 100.0);
			let actualReg = [x1, y1, x2, y2]
			this.props.dispatch(selectionConfirmed(this.props.device_id, this.props.id, reg, actualReg, 
				imageURLData, this.props.preview.slideName, this.props.startScanning, this.props.loaderCapacity, this.props.preview.specimenType, this.props.preview.onObjectiveType));
		}
	}

	onRetakePreview = () => {
		this.clearSelection();
		this.props.dispatch(initPreviewForScan(this.props.id, this.props.defaultConfig));
		this.props.dispatch(takePreview(this.props.device_id, this.props.id));
	}

	clearSelection = () => {
		this.setState(Object.assign({}, this.state, {
			regions: [],
			slide_name: null,
			reading_barcode: false
		}));
		this.props.dispatch(selectionCancelled(this.props.id));
	}

	paintCell = (x, y) => {
		const thresholdContext = this.thresholdCanvas.getContext('2d');
		var cellWidth = (parseInt(this.state.brushSize / 2)) * 2;
		thresholdContext.clearRect(x - cellWidth / 2, y - cellWidth / 2, cellWidth, cellWidth);
		thresholdContext.fillStyle = this.state.usingBrush ? "#FFFFFF" : "#000000";
		thresholdContext.fillRect(x - cellWidth / 2, y - cellWidth / 2, cellWidth, cellWidth);
	}

	paintCanvas = (event) => {
		if (this.paint) {
			var rect = this.thresholdCanvas.getBoundingClientRect();
			var canvasx = rect.x;
			var canvasy = rect.y;
			var mousex = parseInt(((event.pageX - canvasx) / rect.width) * this.thresholdCanvas.width);
			var mousey = parseInt(((event.pageY - canvasy) / rect.height) * this.thresholdCanvas.height);
			this.paintCell(mousex, mousey);
			cleanUpExtra(this.thresholdCanvas, this.thresholdCanvas.getContext('2d'), this.state.regions);
		}
	}

	startPainting = (event) => {
		this.paint = true;
		this.paintCanvas(event);
	}

	stopPainting = () => this.paint = false;

	selectFullRegion = () => {
		this.setState(Object.assign({}, this.state, {
			regions: [
				{
					data: { index: 0 },
					height: 100,
					isChanging: false,
					new: false,
					width: 100,
					x: 0,
					y: 0,
				}
			], 
			oldState: RegionSelectionConstants.SELECTION_DONE
		}));
		this.confirmClicked();
	}

	toggleTiling = (event) => {
		if (event.target.checked) {
			this.props.dispatch(setDoTilingOnly(this.props.id));
		} else {
			this.props.dispatch(unsetDoTilingOnly(this.props.id));
		}
	}

	readbarcode = () => {
		this.setState({
			reading_barcode: true
		});
		let previewPath = this.props.preview.response.barcodeLocation;
		let url = `/devices/${this.props.device_id}/read_barcode/?path=${previewPath}`;  
		axios.get(url).then(res => {
			this.props.dispatch(setScanName(this.props.id, res.data))
			this.setState({
				reading_barcode: false
			});
			if (res.data === "") {
				message.warn("No Barcode found on Slide. Please write Slide Name.")
			}
		})
		.catch(err => {
				console.log(err);
		});
	}

	movedBrushSizeSlider = (value) => this.setState(Object.assign({}, this.state, { brushSize: value }));

	toggleBrushEraser = () => this.setState(Object.assign({}, this.state, { usingBrush: !this.state.usingBrush }))

	previewCanvasRef = previewCanvas => this.previewCanvas = previewCanvas;

	thresholdCanvasRef = thresholdCanvas => this.thresholdCanvas = thresholdCanvas;

	onScanSpeedChange = (event) => this.props.dispatch(setScanSpeed(this.props.id, event.target.value));

	onSpecimenTypeChange = (event) => this.props.dispatch(setSpecimenType(this.props.id, event.target.value));

	onObjectiveTypeChange = (event) => this.props.dispatch(setObjectiveType(this.props.id, event.target.value));

	onScanOutputFormatChange = (event) => this.props.dispatch(setScanOutputFormat(this.props.id, event.target.value));

    scanAllSlots = () => {
		this.props.dispatch(takeAllPreviews(this.props.device_id, this.props.loaderCapacity, this.props.setShowSummary));
    }

	onScanNameChange = (event) => {
		let slide_name = event.target.value;
		this.setState({
			slide_name: slide_name
		}, () => this.props.dispatch(setScanName(this.props.id, slide_name)));
	}

	render() {

		let status = (this.props.preview || {}).status;
		let brushComponent = null;
		let speedSetter = null;
		let allowPainting = false;
		let buttonsPanel = null;
		let slotComp = null;
		let slideNameInput = null;
		let scanButton = null;
		let specimenChooser = null;
		let objectiveChooser = null;
		let scanOutputFormatChanger = null;
		let adminPanel = null;

		if (status === RegionSelectionConstants.SELECTION_DONE) {
			brushComponent = getBrushPanel(this.state.usingBrush, this.state.brushSize, this.toggleBrushEraser, this.movedBrushSizeSlider);
			speedSetter = getSpeedPanel(this.onScanSpeedChange, this.props.preview);
			slideNameInput = <Row>
								<Col span={6} offset={9}>
									<span className="arial-font" style={{marginRight:10, fontSize:13}}>Slide Name </span>
									<Spin spinning={this.state.reading_barcode} tip="Trying to Read Barcode...">
										<Search value={this.props.preview.slideName} placeholder={this.props.preview.response.slideName} enterButton="Read Barcode" onChange={this.onScanNameChange} onSearch={this.readbarcode}/>
									</Spin>
								</Col>
							</Row>
			allowPainting = true;
		}

		if (status === RegionSelectionConstants.FETCHED_IMAGE || status === RegionSelectionConstants.SELECTION_DONE) {
			buttonsPanel = [
				getButtonsPanel(status, this.confirmClicked, this.onRetakePreview, this.clearSelection, this.selectFullRegion, this.state.regions.length, this.props.loaderCapacity), 
				<Row key={1}>
					<Col span={6} offset = {9} style={{fontSize:14}}>
						Selected Area : {this.state.regionArea} mm2
					</Col>
				</Row>
			]
		}

		if (status === RegionSelectionConstants.CONFIRMED) {
			buttonsPanel = getConfirmedPanel(this.clearSelection);
		}

		if (this.props.loaderCapacity === 1 && status === RegionSelectionConstants.SELECTION_DONE) {
			scanButton =  <Row className="start-scan-button-div">
							<Button className="start-scan-button" type="danger" icon="scan" size={'large'} onClick={this.confirmClicked}>Start Scanning</Button>
						</Row>;
		}

		let is_superuser = cookie.loadAll().superuser === "true";

		if ( is_superuser && status === RegionSelectionConstants.SELECTION_DONE) {
			adminPanel = getAdminPanel(this.props.preview, this.toggleTiling);
		}

		if (status === RegionSelectionConstants.SELECTION_DONE) {
			specimenChooser = getSpecimenChooser(this.onSpecimenTypeChange, this.props.preview, is_superuser);
			if (this.props.isObjectiveSwitcherPresent) {
				objectiveChooser = getObjectiveChooser(this.onObjectiveTypeChange, this.props.preview)
			}
			if (this.props.allowScanOutputFormatChange) {
				scanOutputFormatChanger = getScanOutputFormatChanger(this.onScanOutputFormatChange, this.props.preview);
			}
		}

		if (this.props.showSummary) {
			slotComp = this.props.summaryDiv;
		} else if (this.props.id === -1 || status === RegionSelectionConstants.NOT_STARTED) { 
			slotComp = [
				<Row key={0} style={{textAlign:"center", fontSize:20, paddingTop:100}}>Select a slot to continue</Row>, 
				<Row key={1} style={{textAlign:"center", fontSize:30}}><Icon type="arrow-left"/></Row>
			]

			if (this.props.loaderCapacity > 1) {
				slotComp.push(
					<Row key={2}>
						<Col span={12} offset={6}>
							<Divider key={2} />
						</Col>
					</Row>
				)
				slotComp.push(
					<Row key={3} className="scan-all-button-div">
						<Button className={"scan-all-button"} type="danger" icon="scan" size={'large'} onClick={this.scanAllSlots}>Scan All Slots</Button>
					</Row>
				)
			}
		} else if (status !== RegionSelectionConstants.ERRORED_OUT) {
			slotComp = [
				<Row key={0} className="slot-header arial-font preview-for-region-selection">
					<Row style={{ fontSize: 18 }}>
						{status !== RegionSelectionConstants.SELECTION_DONE ?
							"Please select the area to scan." :
							"Adjust scan area using the Brush tool."}
					</Row>
					<Row>
						{getCanvasComponent(status, this.previewCanvasRef, this.thresholdCanvasRef, this.state.regions, this.onCanvasUpdate, allowPainting, this.startPainting, this.paintCanvas, this.stopPainting)}
						<Col span={8}>
							{((this.props.preview || {}).response || {}).barcodeLocation == undefined ? <div></div> :
							<img 
								className="barcode"
								src={"/scan-ssd/" + ((this.props.preview || {}).response || {}).barcodeLocation + "?d=" + new Date().getTime()}></img>}
						</Col>
					</Row>
					{brushComponent}
					{speedSetter}
					{slideNameInput}
					{specimenChooser}
					{objectiveChooser}
					{scanOutputFormatChanger}
					{buttonsPanel}
					{adminPanel}
					{scanButton}
				</Row>
			]
		} else {
			slotComp = <Row>Error</Row>;
		}

		return slotComp;
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		preview: state.previewStatusReducer[ownProps.id],
	};
};

export default connect(mapStateToProps)(SlotComponent);